import type { TaskName } from "../TaskName"
import type { TrackedTaskName } from "./TrackedTaskName"

export type TrackedTask = {
  readonly enum: TaskName.TRACKING
  readonly name: TrackedTaskName
  readonly done: number
  readonly total: number | undefined
}
